import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, map, filter, capitalize } from "lodash";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import { fetchGet } from "../../../api/fetch";
import ScrollableTable from "../../Common/Table/ScrollableTable";
import TableCellStyled from "../../Common/TableCellStyled";
import DataPrivacyCompliance from "./DataPrivacyCompliance";
import DataPrivacyConsent from "./DataPrivacyConsent";
import { API_NODE_SERVER } from "../../../constants/api";
import { formatDate } from "../../../utils/date";
import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  tooltip: {
    fontSize: "1em",
    backgroundColor: colors.white,
    borderRadius: "4px",
    maxWidth: 800,
    minWidth: 250,
    padding: "12px",
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  tooltipTitle: {
    fontWeight: 500,
    color: colors.black87,
  },
  tooltipValue: {
    fontWeight: "normal",
    color: colors.black54,
    marginBottom: "10px",
  },
};

const DataPrivacyPoliciesTable = (props) => {
  const {
    classes,
    language,
    policies,
    acceptances,
    setPolicyContent,
    selectedPolicy,
    setSelectedPolicy,
  } = props;

  const downloadPdf = async (src) => {
    try {
      let res = await fetchGet(src, API_NODE_SERVER);
      let blob = await res.blob();
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/pdf",
        })
      );
      setPolicyContent(url);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <ScrollableTable
      columns={[
        {
          name: "profiles_policyDocument",
          minWidth: 150,
        },
        {
          name: "profiles_consent",
          minWidth: 120,
        },
        {
          name: "profiles_dateTime",
          width: 120,
        },
        {
          name: "profiles_compliance",
          minWidth: 120,
        },
      ]}
    >
      {map(policies, (item, index) => (
        <TableRow
          key={index}
          style={{
            backgroundColor:
              get(item, ["id"]) === get(selectedPolicy, ["id"])
                ? colors.activeYellow
                : index % 2 === 0
                  ? colors.white
                  : colors.tableDarkBg,
          }}
        >
          <TableCellStyled>
            <Grid container>
              <Grid item>
                <Grid container direction="column">
                  <Grid item>
                    <span
                      className={classes.link}
                      onClick={() => {
                        setSelectedPolicy(item);
                        downloadPdf(get(item, ["source", "url", language]));
                      }}
                    >
                      {get(item, ["name", language])}
                    </span>
                  </Grid>
                  <Grid
                    item
                    className="text-54"
                    style={{ fontSize: "0.857em" }}
                  >
                    {get(item, ["revision"])
                      ? `(v${get(item, ["revision"])})`
                      : ""}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ marginLeft: "5px" }}>
                <Tooltip
                  title={
                    <Grid container direction="column">
                      <Grid item className={classes.tooltipTitle}>
                        {I18n.get("profiles_name")}
                      </Grid>
                      <Grid item className={classes.tooltipValue}>
                        {get(item, ["name", language])}
                      </Grid>
                      <Grid item className={classes.tooltipTitle}>
                        {I18n.get("profiles_version")}
                      </Grid>
                      <Grid item className={classes.tooltipValue}>
                        {get(item, ["revision"])}
                      </Grid>
                      <Grid item className={classes.tooltipTitle}>
                        {I18n.get("profiles_publishedDate")}
                      </Grid>
                      <Grid item className={classes.tooltipValue}>
                        {get(item, ["published"])
                          ? formatDate(get(item, ["published"]))
                          : "-"}
                      </Grid>
                      <Grid item className={classes.tooltipTitle}>
                        {I18n.get("profiles_compliance")}
                      </Grid>
                      <Grid item className={classes.tooltipValue}>
                        {capitalize(get(item, ["compliance", "compliance"]))}
                      </Grid>
                      <Grid item className={classes.tooltipTitle}>
                        {I18n.get("profiles_complianceDeferral")}
                      </Grid>
                      <Grid item className={classes.tooltipValue}>
                        {get(item, ["compliance", "compliance-deferral"]) &&
                          get(item, ["compliance", "compliance-deferral"]) !== "0"
                          ? `${get(
                            get(item, [
                              "compliance",
                              "compliance-deferral",
                            ]).split(/(\d+)/),
                            [1]
                          )} 
                         ${I18n.get(
                            `profiles_${get(
                              get(item, [
                                "compliance",
                                "compliance-deferral",
                              ]).split(/(\d+)/),
                              [2]
                            )}`
                          )}`
                          : "-"}
                      </Grid>
                      <Grid item className={classes.tooltipTitle}>
                        {I18n.get("profiles_digest")}
                      </Grid>
                      <Grid item className={classes.tooltipValue}>
                        {get(item, ["integrity", language, "digest"])
                          ? `${get(item, [
                            "integrity",
                            language,
                            "digest",
                          ])}-${get(item, ["integrity", language, "value"])}`
                          : "-"}
                      </Grid>
                    </Grid>
                  }
                  classes={{ tooltip: classes.tooltip }}
                  placement="right-start"
                >
                  <img src={images.infoIcon} alt="info" width={"15px"} />
                </Tooltip>
              </Grid>
            </Grid>
          </TableCellStyled>
          <TableCellStyled>
            <DataPrivacyConsent policy={item} acceptances={acceptances} />
          </TableCellStyled>
          <TableCellStyled className="text-54">
            {get(
              filter(
                acceptances,
                (a) => get(a, ["policy", "id"]) === get(item, ["id"])
              ),
              [0, "date"]
            )
              ? formatDate(
                get(
                  filter(
                    acceptances,
                    (a) => get(a, ["policy", "id"]) === get(item, ["id"])
                  ),
                  [0, "date"]
                )
              )
              : "-"}
          </TableCellStyled>
          <TableCellStyled className="text-54">
            <DataPrivacyCompliance policy={item} acceptances={acceptances} />
          </TableCellStyled>
        </TableRow>
      ))}
    </ScrollableTable>
  );
};

export default withStyles(styles)(DataPrivacyPoliciesTable);
